<template>
  <div id="customTab">
    <h2 class="mt-2">{{ tab.title }}</h2>
    <iframe
      v-if="tab.mode === 'embed'"
      width="100%"
      height="550"
      :src="tab.content"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
    <div
      v-if="tab.mode === 'richText' || tab.mode === 'html'"
      v-html="tab.content"
    ></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      tab: {}
    }
  },
  computed: {
    ...mapState([
      'dashboard'
    ])
  },
  mounted () {
    let selectedTab = this.dashboard.selectedCustomTab
    this.tab = this.dashboard.data.modules.customTabs.tabs[selectedTab]
  },
}
</script>

<style>
#customTab h1 a, #customTab h2 a, #customTab h3 a {
  color: #eee;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 5px 10px;
  transition: all 0.3s ease;
}
#customTab h1 a:hover, #customTab h2 a:hover, #customTab h3 a:hover {
  color: #333;
  background-color: #eee;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomTabs.vue